<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Редактировать клиента
    </h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'apartment-client-details', params: { client_id: client.id }}">← Назад к Деталям клиента</router-link>
    </div>

    <div class="text-right">
      <a v-if="client.id" class="red" href="#" @click.prevent="deleteClient">удалить клиента</a>
    </div>

    <client-edit-form
      :client="client"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getClient, deleteClient } from '@/services/client.service'
import clientEditForm from '@/components/forms/client/ClientEditForm'

export default {
  name: 'client-edit',
  components: { clientEditForm },
  data () {
    return {
      client: {
        id: null,
        first_name: '',
        last_name: '',
        middle_name: '',
        phone: '',
        contract_number: '',
        apartment: '',
        rate_plan: '',
        discount: ''
      },

      errors: {
        client: {
          id: [],
          first_name: [],
          last_name: [],
          middle_name: [],
          phone: [],
          contract_number: [],
          apartment: [],
          rate_plan: [],
          discount: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.client_id !== undefined) {
      this.client.id = this.$route.params.client_id

      getClient(this.client.id).then((response) => {
        this.client = response.data
      })
    }
  },
  methods: {
    deleteClient () {
      deleteClient(this.client.id).then((response) => {
        this.showMsg('Клиент был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'apartment-details', params: { apartment_id: this.$route.params.apartment_id } })
        return true
      }).catch(err => {
        console.log(err)
        this.showMsg('Клиент был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'apartment-details', params: { apartment_id: this.$route.params.apartment_id } })
        return true
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClientEdit.vue?33f7e2bd